import React, { Component } from "react";
import "./Loader.scss";
// import { ReactComponent as CompanyLogo } from "../../assets/radarr-logo.svg";
import NavbarContainer from "../Navbar/NavbarContainer";

import { withRouter } from "react-router-dom";
import { loaderText } from "./loaderUtils";

class Loader extends Component {
    render() {
        return (
            <div className={`main-loader ${this.props.className}`}>
                {this.props.className !== "fullpage-loader" && <NavbarContainer history={this.props.history} location={this.props.location} />}
                <div className="loader">
                    <div className="loader__bar"></div>
                    <div className="loader__bar"></div>
                    <div className="loader__bar"></div>
                    <div className="loader__bar"></div>
                    <div className="loader__bar"></div>
                    <div className="loader__ball"></div>
                </div>
                {/* <div className="loader-text">{loaderText[Math.floor(Math.random() * loaderText.length)]}</div> */}
            </div>
        );
    }
}

export default withRouter(Loader);
// export default Loader;
